// dummyProducts.js
export const products = [
  {
    _id: "prd001",
    productName: "Pro Training Basket Ball",
    productCategory: "Sports",
    productSubCategory: "Football",
    productDescription: "Approved training football with high durability.",
    productSize: ["4", "5"],
    productColors: ["White", "Black"],
    productPrice: "1299",
    vendorid: "65a1a1a1a1a1a1a1a1a1a1a2",
    isDeal: true,
    images: [
      "https://images.unsplash.com/photo-1521412644187-c49fa049e84d"
    ],
    isStock: true,
    rating: ["5", "4", "5"]
  },
  {
    _id: "prd002",
    productName: "Premium Cricket Bat",
    productCategory: "Sports",
    productSubCategory: "Cricket",
    productDescription: "English willow bat for power hitters.",
    productSize: ["Short Handle", "Long Handle"],
    productColors: ["Wood"],
    productPrice: "3499",
    vendorid: "65a1a1a1a1a1a1a1a1a1a1a2",
    isDeal: false,
    images: [
      "https://images.unsplash.com/photo-1593766827228-8737b4534aa6"
    ],
    isStock: true,
    rating: ["5", "5", "4"]
  },

  {
    _id: "prd003",
    productName: "Running Shoes",
    productCategory: "Footwear",
    productSubCategory: "Running",
    productDescription: "Lightweight shoes for long-distance running.",
    productSize: ["7", "8", "9", "10"],
    productColors: ["Blue", "Black", "Red"],
    productPrice: "2799",
    vendorid: "65a1a1a1a1a1a1a1a1a1a1a2",
    isDeal: true,
    images: [
      "https://images.unsplash.com/photo-1542291026-7eec264c27ff"
    ],
    isStock: true,
    rating: ["4", "5", "4"]
  },

  {
    _id: "prd004",
    productName: "Gym Dumbbells Set",
    productCategory: "Fitness",
    productSubCategory: "Gym",
    productDescription: "Adjustable dumbbell set for home workouts.",
    productSize: ["10kg", "20kg"],
    productColors: ["Black"],
    productPrice: "2199",
    vendorid: "65a1a1a1a1a1a1a1a1a1a1a2",
    isDeal: false,
    images: [
      "https://images.unsplash.com/photo-1583454110551-21f2fa2afe61"
    ],
    isStock: true,
    rating: ["5", "5"]
  },

  {
    _id: "prd005",
    productName: "Ropes",
    productCategory: "Fitness",
    productSubCategory: "Ropes",
    productDescription: "Non-slip ropes for training.",
    productSize: ["Standard"],
    productColors: ["Purple", "Green", "Black"],
    productPrice: "899",
    vendorid: "65a1a1a1a1a1a1a1a1a1a1a2",
    isDeal: true,
    images: [
      "https://images.unsplash.com/photo-1599058917212-d750089bc07e"
    ],
    isStock: true,
    rating: ["4", "4", "5"]
  }
];


